// ** React Imports
import { useState, ElementType, ChangeEvent, SyntheticEvent, useEffect } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Select from '@mui/material/Select'
import Dialog from '@mui/material/Dialog'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'
import Checkbox from '@mui/material/Checkbox'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputLabel from '@mui/material/InputLabel'
import CardHeader from '@mui/material/CardHeader'
import FormControl from '@mui/material/FormControl'
import CardContent from '@mui/material/CardContent'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import FormHelperText from '@mui/material/FormHelperText'
import InputAdornment from '@mui/material/InputAdornment'
import Button, { ButtonProps } from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormGroup from '@mui/material/FormGroup'

// ** Third Party Imports
import { useForm, Controller } from 'react-hook-form'

import moment from 'moment'
import 'moment/locale/id'
import { Alert, AlertTitle, DialogTitle, Fab, IconButton, OutlinedInput, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import { TabContext, TabList, TabPanel } from '@mui/lab'
import axios from 'axios'
import Swal from 'sweetalert2'

import { useNavigate, useParams } from "react-router-dom";

import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang, getProses } from '../../../../api/helper';
import { useToast } from '../../../../components/ToastProvider';

import DialogOtorisasi from '../../../../components/custom/DialogOtorisasi';
import AttachmentFab from '../../../../components/attachment/AttachmentFab'
import FloatingJurnalButton from '../../../../components/acc/jurnal/FabJurnal'

// Fungsi untuk format angka jadi ribuan
const formatNumber = (val: any) => {
    const num = Number(val);
    if (isNaN(num)) return '';
    return num.toLocaleString('id-ID');
};

const terbilang = (nominal: number) => {
    if (isNaN(nominal) || nominal < 0) return 'Nominal tidak valid'

    const satuan = ['', 'satu', 'dua', 'tiga', 'empat', 'lima', 'enam', 'tujuh', 'delapan', 'sembilan', 'sepuluh', 'sebelas']

    const penyebut = (n: number): string => {
        if (n < 12) return satuan[n]
        if (n < 20) return `${penyebut(n - 10)} belas`
        if (n < 100) return `${penyebut(Math.floor(n / 10))} puluh ${penyebut(n % 10)}`
        if (n < 200) return `seratus ${penyebut(n - 100)}`
        if (n < 1000) return `${penyebut(Math.floor(n / 100))} ratus ${penyebut(n % 100)}`
        if (n < 2000) return `seribu ${penyebut(n - 1000)}`
        if (n < 1000000) return `${penyebut(Math.floor(n / 1000))} ribu ${penyebut(n % 1000)}`
        if (n < 1000000000) return `${penyebut(Math.floor(n / 1000000))} juta ${penyebut(n % 1000000)}`
        if (n < 1000000000000) return `${penyebut(Math.floor(n / 1000000000))} miliar ${penyebut(n % 1000000000)}`
        return 'Angka terlalu besar'
    }

    const result = penyebut(Math.floor(nominal))?.replace(/\s+/g, ' ').trim() || ''

    return `${result} rupiah`
}

const Detail = () => {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const { id } = useParams();

    // ** State
    const [tglDokumen, setTglDokumen] = useState<string>(moment().format('YYYY-MM-DD'))

    const [tagihan, setTagihan] = useState<any>(null)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogBatal, setOpenDialogBatal] = useState<boolean>(false)

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [isOto, setIsOto] = useState<any>(null)
    const [isAktif, setIsAktif] = useState<any>(null)
    const [dataOtorisasi, setDataOtorisasi] = useState<any>({
        menu: 'Invoice Receipt',
        id: id,
        tabel: 'accir',
        doctag: ''
    })

    const [listData, setListData] = useState<any[]>([])

    // build initial arrays
    let initialPengurangan: any[] = [
        {
            accakun_id: 4000011,
            akun: 'PENDAPATAN LAINNYA',
            total: 0,
            keterangan: '',
            petunjuk: 'SALAH HARGA (-)'
        },
        {
            accakun_id: 800005,
            akun: 'PENDAPATAN SELISIH KURS',
            total: 0,
            keterangan: '',
            petunjuk: 'SELISIH KURS'
        },
        {
            accakun_id: 700099,
            akun: 'DISKON PEMBELIAN',
            total: 0,
            keterangan: '',
            petunjuk: 'DISKON PEMBELIAN'
        },
    ]

    let initialPenambahan: any[] = [
        {
            accakun_id: 800099,
            akun: 'BIAYA PEMBELIAN LAI LAIN',
            total: 0,
            keterangan: '',
            petunjuk: 'SALAH HARGA (+)'
        },
        {
            accakun_id: 800005,
            akun: 'BIAYA SELISIH KURS',
            total: 0,
            keterangan: '',
            petunjuk: 'SELISIH KURS'
        },
        {
            accakun_id: 510204,
            akun: 'BIAYA ANGKUT DAN EXPEDISI PEMBELIAN',
            total: 0,
            keterangan: '',
            petunjuk: 'JASA ANGKUTAN'
        },
        {
            accakun_id: 622005,
            akun: 'BIAYA SUPPLIES KOMPUTER, ATK & METERAI',
            total: 0,
            keterangan: '',
            petunjuk: 'ATK & METERAI'
        },
    ]

    const [listDataPengurangan, setListDataPengurangan] = useState<any[]>(initialPengurangan)
    const [listDataPenambahan, setListDataPenambahan] = useState<any[]>(initialPenambahan)
    const [listSupplier, setListSupplier] = useState<any[]>([])


    const [inputKeterangan, setInputKeterangan] = useState<any>('')
    const [required, setRequired] = useState(false)
    const [isError, setIsError] = useState(false)

    const convertDate = (pdate: Date) => {
        const yyyy = pdate.getFullYear()
        let mm = pdate.getMonth() + 1
        let dd = pdate.getDate()

        let sdd: string = dd.toString()
        let smm: string = mm.toString()

        if (dd < 10) sdd = '0' + dd
        if (mm < 10) smm = '0' + mm

        const formatted = sdd + '-' + smm + '-' + yyyy

        return formatted
    }

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/acc/invoice-receipt/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    const master = response.data.data[0]

                    const oto = dataOtorisasi
                    oto.doctag = master.sysdoctag_id
                    setDataOtorisasi(oto)

                    setValue('sysdoctag_id', master.sysdoctag_id)
                    setValue('supplier_id', master.pbsupplier_id)
                    setValue('supplier_name', master.nama_vendor)
                    setValue('tgl_nota', moment(master.tgl_nota).format('YYYY-MM-DD'))
                    setValue('no_nota', master.nomor_nota)
                    setValue('no_faktur', master.nomor_faktur)
                    setValue('top', master.payment)
                    setTglDokumen(master.tgl)
                    setValue('tgl_jatuh_tempo', moment(master.tgl_jth_tempo).format('YYYY-MM-DD'))
                    setValue('tagihan', master.tagihan)
                    setTagihan(master.tagihan)
                    setValue('total_valas', master.total_valas)
                    setValue('total', master.total)
                    setValue('total_ppn', master.total_ppn)
                    setValue('total_valas_ppn', master.total_valas_ppn)
                    setValue('keterangan', master.keterangan)
                    setIsAktif(master.is_aktif)

                    const detail = response.data.detail
                    setListData(detail)

                    const biaya = response.data.biaya
                    if (Array.isArray(biaya)) {
                        const pengurangan = [...listDataPengurangan]
                        const penambahan = [...listDataPenambahan]
                        biaya.forEach(b => {
                            const idxPengurangan = pengurangan.findIndex(x => x.accakun_id === b.accakun_id)
                            if (idxPengurangan !== -1) {
                                pengurangan[idxPengurangan].total_pengajuan = b.total_pengajuan
                                pengurangan[idxPengurangan].total_acc = b.total
                                pengurangan[idxPengurangan].id = b.id
                                pengurangan[idxPengurangan].keterangan = b.keterangan || ''
                            }
                            const idxPenambahan = penambahan.findIndex(x => x.accakun_id === b.accakun_id)
                            if (idxPenambahan !== -1) {
                                penambahan[idxPenambahan].total_pengajuan = b.total_pengajuan
                                penambahan[idxPenambahan].total_acc = b.total
                                penambahan[idxPenambahan].id = b.id
                                penambahan[idxPenambahan].keterangan = b.keterangan || ''
                            }
                        })
                        setListDataPengurangan(pengurangan)
                        setListDataPenambahan(penambahan)
                    }
                    getSupplier()
                    getUserOto(master.sysdoctag_id)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSupplier = () => {
        const url = apiUrl.apiUrl + '/acc/invoice-receipt/get-supplier'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSupplier(data)
                    data.forEach((element: any) => {
                        if (element.id === getValues('supplier_id')) {
                            setValue('alamat', element.alamat)
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getPenerimaan = (ids: any) => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/acc/invoice-receipt/get-penerimaan'
        axios
            .get(url, {
                params: { tgl_awal: tglAwal, tgl_akhir: tglAkhir, supplier_id: ids },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getUserOto = (sysdoctag_id: any) => {
        const url = apiUrl.apiUrl + '/system/user/cek-oto'
        axios
            .get(url, {
                params: { sysdoctag_id: sysdoctag_id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setIsOto(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    interface FormInputs {
        sysdoctag_id: any
        supplier_id: any
        supplier_name: any
        alamat: any
        tgl_nota: any
        no_nota: any
        no_faktur: any
        keterangan: any
        top: any
        tgl_jatuh_tempo: any
        kurir: any
        tagihan: any
        total_valas: any
        total: any
        total_valas_ppn: any
        total_ppn: any
        detail: any
        biayaLain: any
    }

    const defaultValues = {
        tagihan: 0,
        top: 0
    }

    // ** Hooks
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            html: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/invoice-receipt/save-oto/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const updateData = () => {
        const data = getValues()

        Swal.fire({
            title: 'Konfirmasi',
            html: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/invoice-receipt/update/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleTable = (row: any, value: any, name: any, mode: any) => {
        if (mode === 'pengurangan') {
            const index = listDataPengurangan.findIndex(o => o.accakun_id === row.accakun_id);
            const rowsInput = [...listDataPengurangan];
            rowsInput[index][name] = value;
            setListDataPengurangan(rowsInput);
        } else {
            const index = listDataPenambahan.findIndex(o => o.accakun_id === row.accakun_id);
            const rowsInput = [...listDataPenambahan];
            rowsInput[index][name] = value;
            setListDataPenambahan(rowsInput);
        }
    };

    const rowClick = (e: any) => {
        const item = e.data
        setValue('supplier_id', item.id)
        setValue('supplier_name', item.nama)
        setValue('alamat', item.alamat)
        setValue('top', item.payment)
        getPenerimaan(item.id)
        setOpenDialog(false)
    }

    const renderMaster = () => {
        return (
            <CardContent>
                <Grid container spacing={6}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Supplier
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='supplier_name'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <>
                                        <InputLabel htmlFor='input-file'>Supplier</InputLabel>
                                        <OutlinedInput
                                            label='Supplier'
                                            value={value}
                                            id='input-file'
                                            readOnly
                                            type={'text'}
                                            error={Boolean(errors.supplier_name)}
                                            startAdornment={
                                                <Box onClick={() => setOpenDialog(true)} style={{ cursor: 'pointer' }}>
                                                    <InputAdornment position='start'>
                                                        Cari &nbsp;
                                                        <IconButton edge='start' onMouseDown={e => e.preventDefault()} aria-label='search'>
                                                            <Icon fontSize={20} icon={'mdi:search'} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                </Box>
                                            }
                                        />
                                    </>
                                )}
                            />
                            {errors.supplier_name && <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Alamat
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='alamat'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        multiline
                                        rows={1}
                                        label='Alamat'
                                        error={Boolean(errors.alamat)}
                                        onChange={onChange}
                                        value={value}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                )}
                            />
                            {errors.alamat && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Tanggal Nota
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tgl_nota'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Tanggal Nota'
                                            type='date'
                                            error={Boolean(errors.tgl_nota)}
                                            onChange={e => {
                                                onChange(e)
                                                // Hitung tgl_jatuh_tempo jika payment/top ada
                                                const top = getValues('top')
                                                const tglNota = e.target.value
                                                if (tglNota && top && !isNaN(Number(top))) {
                                                    const jatuhTempo = moment(tglNota).add(Number(top), 'days').format('YYYY-MM-DD')
                                                    setValue('tgl_jatuh_tempo', jatuhTempo)
                                                }
                                            }}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.tgl_nota && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            No. Nota
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='no_nota'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='No. Nota'
                                            error={Boolean(errors.no_nota)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ min: 0 }}
                                        />
                                    )
                                }}
                            />
                            {errors.no_nota && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            No. Faktur
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='no_faktur'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='No. Faktur'
                                            type='number'
                                            error={Boolean(errors.no_faktur)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.no_faktur && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            TOP
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='top'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='TOP'
                                            type='number'
                                            error={Boolean(errors.top)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.top && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Tanggal Jatuh Tempo
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tgl_jatuh_tempo'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Tanggal Jatuh Tempo'
                                            type='date'
                                            error={Boolean(errors.tgl_jatuh_tempo)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.tgl_jatuh_tempo && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Kurir
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='kurir'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Kurir'
                                            error={Boolean(errors.kurir)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.kurir && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Tagihan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tagihan'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            fullWidth
                                            label='Tagihan'
                                            name='tagihan'
                                            value={formatNumber(value)}
                                            onChange={e => {
                                                const val = e.target.value.replace(/\D/g, '')
                                                setValue('tagihan', val)
                                                setTagihan(val)
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ inputMode: 'numeric' }}
                                        />
                                    )
                                }}
                            />
                            {errors.tagihan && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Tagihan Terbilang
                        </Typography>
                        <Typography variant='h5' sx={{ textTransform: 'uppercase' }}>
                            {tagihan == null ? (<>0</>) : (
                                <>
                                    {terbilang(tagihan)}
                                </>
                            )}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 4 }}>
                            Keterangan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='keterangan'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Keterangan'
                                            rows={2}
                                            multiline
                                            error={Boolean(errors.keterangan)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.keterangan && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        )
    }

    const sumTotalValasPPN = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.TotalValasPPN) || 0 : 0), 0)
        : 0;

    const sumValas = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.Valas) || 0 : 0), 0)
        : 0;

    const sumTotal = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.Total) || 0 : 0), 0)
        : 0;

    const sumTotalPPN = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.TotalPPN) || 0 : 0), 0)
        : 0;

    const renderDetail = () => {
        return (
            <CardContent>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                p: 5,
                                pb: 3,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography variant='h6'>DAFTAR PENERIMAAN</Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                label='Tanggal Awal'
                                type='date'
                                onChange={(e) => setTglAwal(e.target.value)}
                                value={tglAwal}
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                label='Tanggal Akhir'
                                type='date'
                                onChange={(e) => setTglAkhir(e.target.value)}
                                value={tglAkhir}
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FormControl>
                            <Button
                                sx={{ marginTop: 1, width: 'auto' }}
                                variant='contained'
                                color='secondary'
                                startIcon={<Icon icon='mdi:magnify' />}
                                onClick={getDetail}
                            >
                                Cari Data
                            </Button>
                        </FormControl>
                    </Grid>
                </Grid>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Dibayar</TableCell>
                                <TableCell>ID PO</TableCell>
                                <TableCell>Tgl GR</TableCell>
                                <TableCell>No. Penerimaan</TableCell>
                                <TableCell>Surat Jalan</TableCell>
                                <TableCell>Barang</TableCell>
                                <TableCell>Total</TableCell>
                            </TableRow >
                        </TableHead >
                        <TableBody>
                            {listData.map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Checkbox
                                                checked={item.is_pay === 1}
                                                onChange={e => {
                                                    const updatedList = [...listData]
                                                    updatedList[index].is_pay = e.target.checked ? 1 : 0
                                                    setListData(updatedList)
                                                }}
                                                color="primary"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <a
                                                href={'/purchasing/purchase-order/detail/' + item.pbpo_id}
                                                style={{ textDecoration: 'none' }}
                                                target='_blank'
                                            >
                                                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>{item.pbpo_id}</Typography>
                                            </a>
                                        </TableCell>
                                        <TableCell>{item.TanggalPenerimaan}</TableCell>
                                        <TableCell>
                                            <a
                                                href={'/purchasing/good-receipt/detail/' + item.NomorPenerimaan}
                                                style={{ textDecoration: 'none' }}
                                                target='_blank'
                                            >
                                                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>{item.NomorPenerimaan}</Typography>
                                            </a>
                                        </TableCell>
                                        <TableCell>{item.NoSuratJln}</TableCell>
                                        <TableCell>{item.Keterangan}</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>{formatNumber(item.Total)}</TableCell>
                                    </TableRow>
                                )
                            })}
                            <TableRow sx={{ backgroundColor: '#FFE995' }}>
                                <TableCell colSpan={6} sx={{ textAlign: 'right' }}><b>TOTAL :</b></TableCell>
                                <TableCell sx={{ textAlign: 'right' }}><b>{formatNumber(sumTotal)}</b></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table >
                </TableContainer >
            </CardContent >
        )
    }

    // TOTAL PENGURANGAN
    const totalPengurangan = listDataPengurangan.reduce(
        (acc, curr) => acc + (Number(curr.total_pengajuan) || 0),
        0
    )
    const totalPenguranganAcc = listDataPengurangan.reduce(
        (acc, curr) => acc + (Number(curr.total_acc) || 0),
        0
    )

    // TOTAL PENAMBAHAN
    const totalPenambahan = listDataPenambahan.reduce(
        (acc, curr) => acc + (Number(curr.total_pengajuan) || 0),
        0
    )
    const totalPenambahanAcc = listDataPenambahan.reduce(
        (acc, curr) => acc + (Number(curr.total_acc) || 0),
        0
    )

    const renderPengurangan = () => {
        return (
            <CardContent>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                p: 5,
                                pb: 3,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography variant='h6'>PENGURANGAN TAGIHAN</Typography>
                            <Button
                                variant='contained'
                                color='secondary'
                                startIcon={<Icon icon='mdi:content-copy' />}
                                onClick={() => {
                                    setListDataPengurangan(prev =>
                                        prev.map(item => ({
                                            ...item,
                                            total_acc: item.total_pengajuan
                                        }))
                                    )
                                }}
                            >
                                Copy Total
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <Table key={1}>
                    <TableHead>
                        <TableRow>
                            <TableCell>PETUNJUK</TableCell>
                            <TableCell>TOTAL</TableCell>
                            <TableCell>TOTAL ACC</TableCell>
                            <TableCell>KETERANGAN</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDataPengurangan.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.petunjuk}</TableCell>
                                <TableCell>{item.total_pengajuan}</TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label="Total Acc"
                                        name="total_acc"
                                        onChange={e => {
                                            let input = e.target.value

                                            // Izinkan minus di depan, hapus karakter selain angka, koma, dan minus di depan
                                            input = input.replace(/(?!^-)[^0-9,]/g, '')

                                            // Pastikan hanya satu minus di depan
                                            if (input.includes('-')) {
                                                input = input.replace(/(?!^)-/g, '')
                                            }

                                            // Pisahkan bagian integer dan desimal
                                            const [intPartRaw, decimalPart] = input.split(',')
                                            // Pastikan minus hanya di depan integer
                                            let intPart = intPartRaw || ''
                                            let formatted = ''
                                            if (intPart) {
                                                const parsed = parseInt(intPart, 10)
                                                formatted = isNaN(parsed) ? intPart : parsed.toLocaleString('id-ID')
                                                if (intPart.startsWith('-') && !formatted.startsWith('-')) {
                                                    formatted = '-' + formatted
                                                }
                                            }

                                            if (decimalPart !== undefined) {
                                                formatted += ',' + decimalPart
                                            }

                                            // Raw value untuk backend: ganti koma ke titik
                                            const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                            // Kirim nilai mentah ke handler
                                            handleTable(item, rawValue, 'total_acc', 'pengurangan')

                                            // Simpan formatted display ke item, kalau kamu pakai state management sendiri
                                            item.formatted_total_acc = formatted
                                        }}
                                        value={
                                            item.formatted_total_acc ??
                                            (item.total_acc !== undefined && item.total_acc !== null && item.total_acc !== ''
                                                ? (() => {
                                                    const str = String(item.total_acc).replace('.', ',')
                                                    const [integer, decimal] = str.split(',')
                                                    let formatted = ''
                                                    if (integer) {
                                                        // Tangani minus
                                                        const parsed = parseInt(integer, 10)
                                                        formatted = isNaN(parsed)
                                                            ? integer
                                                            : (integer.startsWith('-') ? '-' : '') + Math.abs(parsed).toLocaleString('id-ID')
                                                    }
                                                    if (decimal !== undefined) {
                                                        formatted += ',' + decimal
                                                    }
                                                    return formatted
                                                })()
                                                : '')
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ inputMode: 'decimal' }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label='Keterangan'
                                        name='keterangan'
                                        rows={2}
                                        multiline
                                        onChange={e => {
                                            const val = e.target.value
                                            handleTable(item, val, 'keterangan', 'pengurangan')
                                        }}
                                        value={item.keterangan}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: '#FFE995' }}>
                            <TableCell><b>TOTAL</b></TableCell>
                            <TableCell><b>{formatNumber(totalPengurangan)}</b></TableCell>
                            <TableCell><b>{formatNumber(totalPenguranganAcc)}</b></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        )
    }

    const renderPenambahan = () => {
        return (
            <CardContent>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                p: 5,
                                pb: 3,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography variant='h6'>PENAMBAHAN TAGIHAN</Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    startIcon={<Icon icon='mdi:content-copy' />}
                                    onClick={() => {
                                        setListDataPenambahan(prev =>
                                            prev.map(item => ({
                                                ...item,
                                                total_acc: item.total_pengajuan
                                            }))
                                        )
                                    }}
                                >
                                    Copy Total
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Table key={1}>
                    <TableHead>
                        <TableRow>
                            <TableCell>PETUNJUK</TableCell>
                            <TableCell>TOTAL</TableCell>
                            <TableCell>TOTAL ACC</TableCell>
                            <TableCell>KETERANGAN</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDataPenambahan.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.petunjuk}</TableCell>
                                <TableCell>{item.total_pengajuan}</TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label="Total Acc"
                                        name="total_acc"
                                        onChange={e => {
                                            let input = e.target.value

                                            // Izinkan minus di depan, hapus karakter selain angka, koma, dan minus di depan
                                            input = input.replace(/(?!^-)[^0-9,]/g, '')

                                            // Pastikan hanya satu minus di depan
                                            if (input.includes('-')) {
                                                input = input.replace(/(?!^)-/g, '')
                                            }

                                            // Pisahkan bagian integer dan desimal
                                            const [intPartRaw, decimalPart] = input.split(',')
                                            // Pastikan minus hanya di depan integer
                                            let intPart = intPartRaw || ''
                                            let formatted = ''
                                            if (intPart) {
                                                const parsed = parseInt(intPart, 10)
                                                formatted = isNaN(parsed) ? intPart : parsed.toLocaleString('id-ID')
                                                if (intPart.startsWith('-') && !formatted.startsWith('-')) {
                                                    formatted = '-' + formatted
                                                }
                                            }

                                            if (decimalPart !== undefined) {
                                                formatted += ',' + decimalPart
                                            }

                                            // Raw value untuk backend: ganti koma ke titik
                                            const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                            // Kirim nilai mentah ke handler
                                            handleTable(item, rawValue, 'total_acc', 'penambahan')

                                            // Simpan formatted display ke item, kalau kamu pakai state management sendiri
                                            item.formatted_total_acc = formatted
                                        }}
                                        value={
                                            item.formatted_total_acc ??
                                            (item.total_acc !== undefined && item.total_acc !== null && item.total_acc !== ''
                                                ? (() => {
                                                    const str = String(item.total_acc).replace('.', ',')
                                                    const [integer, decimal] = str.split(',')
                                                    let formatted = ''
                                                    if (integer) {
                                                        // Tangani minus
                                                        const parsed = parseInt(integer, 10)
                                                        formatted = isNaN(parsed)
                                                            ? integer
                                                            : (integer.startsWith('-') ? '-' : '') + Math.abs(parsed).toLocaleString('id-ID')
                                                    }
                                                    if (decimal !== undefined) {
                                                        formatted += ',' + decimal
                                                    }
                                                    return formatted
                                                })()
                                                : '')
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ inputMode: 'decimal' }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label='Keterangan'
                                        name='keterangan'
                                        rows={2}
                                        multiline
                                        onChange={e => {
                                            const val = e.target.value
                                            handleTable(item, val, 'keterangan', 'penambahan')
                                        }}
                                        value={item.keterangan}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: '#FFE995' }}>
                            <TableCell><b>TOTAL</b></TableCell>
                            <TableCell><b>{formatNumber(totalPenambahan)}</b></TableCell>
                            <TableCell><b>{formatNumber(totalPenambahanAcc)}</b></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        )
    }

    const totalIncludePPN = sumTotalPPN

    const valTagihan = Number(getValues('tagihan') || 0);
    const totalHitung = totalIncludePPN + totalPenambahanAcc - totalPenguranganAcc;

    // bulatkan ke 2 desimal (misalnya uang)
    const isTagihanValid = Math.round(valTagihan * 100) === Math.round(totalHitung * 100);

    // const isTagihanValid =
    //     Number(getValues('tagihan') || 0) ===
    //     totalIncludePPN + totalPenambahanAcc - totalPenguranganAcc

    useEffect(() => {
        setValue('total_valas_ppn', sumTotalValasPPN)
        setValue('total_valas', sumValas)
        setValue('total', sumTotal)
        setValue('total_ppn', sumTotalPPN)
        setValue('detail', JSON.stringify(listData))
        setValue(
            'biayaLain',
            JSON.stringify([
                ...listDataPengurangan
                    .filter(item => Number(item.total_acc) !== 0)
                    .map(item => ({ ...item, total: item.total_acc, jenis: 'pengurangan' })),
                ...listDataPenambahan
                    .filter(item => Number(item.total_acc) !== 0)
                    .map(item => ({ ...item, total: item.total_acc, jenis: 'penambahan' }))
            ])
        )
    }, [
        sumTotalValasPPN,
        sumValas,
        sumTotal,
        sumTotalPPN,
        listData,
        listDataPengurangan,
        listDataPenambahan,
        setValue
    ])

    const batalDokumen = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin membatalkan dokumen ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Batalkan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const send = { keterangan_hapus: inputKeterangan }
                const url = apiUrl.apiUrl + '/acc/invoice-receipt/hapus-dokumen/' + id
                axios
                    .post(url, send, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/acc/invoice-receipt')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleBatalDokumen = () => {
        if (inputKeterangan == '') {
            setRequired(true)
        } else {
            setOpenDialogBatal(false)
            setInputKeterangan('')
            batalDokumen()

        }
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            handleBatalDokumen()
        }
    }

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Card>
                    <Typography variant='h5' sx={{ textAlign: 'center', m: 3 }}>
                        Detail Invoice Receipt
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        Jenis Dokumen :
                        <b>
                            {getValues('sysdoctag_id') == 666
                                ? ' Penerimaan Tagihan Oto GMSD'
                                : getValues('sysdoctag_id') == 665
                                    ? ' Penerimaan Tagihan Oto GMPD'
                                    : getValues('sysdoctag_id') == 413
                                        ? ' Penerimaan Tagihan (PUR)'
                                        : ''}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        Tgl. Dokumen : <b>{moment(tglDokumen).format('LL')}</b>
                    </Typography>
                    <Divider />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {renderMaster()}
                        <Divider />
                        {renderDetail()}
                        {renderPengurangan()}
                        {renderPenambahan()}
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {isAktif == 0 ? (
                                <>
                                    {isTagihanValid ? (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mt: 5
                                            }}
                                        >

                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mb: 4, mr: 5 }}>
                                                <Button variant='contained' onClick={updateData} sx={{ m: 3 }}>
                                                    SIMPAN
                                                </Button>
                                                {isOto === 0 ? ('') : (
                                                    <>
                                                        <Button variant='contained' type='submit' color='success' sx={{ m: 3 }}>
                                                            SIMPAN & OTORISASI
                                                        </Button>
                                                        <Button variant='contained' color='error' onClick={() => setOpenDialogBatal(true)} sx={{ m: 3 }}>
                                                            BATALKAN DOKUMEN
                                                        </Button>
                                                    </>
                                                )}
                                            </Box>

                                        </Box>
                                    ) : (
                                        <Alert severity='error' sx={{ width: '100%' }}>
                                            <AlertTitle>Warning</AlertTitle>
                                            TOTAL BELUM SAMA. SELISIH TAGIHAN : <b>
                                                {formatNumber(
                                                    Math.abs(
                                                        (Number(getValues('tagihan') || 0)) -
                                                        (totalIncludePPN + totalPenambahanAcc - totalPenguranganAcc)
                                                    )
                                                )}
                                            </b>
                                        </Alert>
                                    )}
                                </>
                            ) : (
                                <Button variant='contained' color='inherit' onClick={() => navigate('/acc/invoice-receipt')} sx={{ m: 3 }}>
                                    KEMBALI
                                </Button>
                            )}
                        </Box>
                    </form>
                </Card>
            </Grid>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
            >
                <DialogTitle id='form-dialog-title'>Pilih Supplier</DialogTitle>
                <DialogContent>
                    <MsiDatagrid array={listSupplier} rowClick={rowClick} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button
                        onClick={() => setOpenDialog(false)}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogBatal}
                onClose={() => setOpenDialogBatal(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>Keterangan Pembatalan Dokumen</DialogTitle>
                <DialogContent>
                    <TextField
                        sx={{ my: 3 }}
                        id='keterangan'
                        autoFocus
                        fullWidth
                        rows={3}
                        multiline
                        label='Keterangan'
                        onChange={e => setInputKeterangan(e.target.value)}
                        onKeyDown={handleKeyDown}
                        InputLabelProps={{ shrink: true }}
                        error={required}
                    />
                    {required ? (
                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                    ) : (
                        <div></div>
                    )}
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogBatal(false)}>Batal</Button>
                    <Button variant='contained' onClick={handleBatalDokumen}>
                        Simpan
                    </Button>
                </DialogActions>
            </Dialog>


            <FloatingJurnalButton
                id={Number(id)}
                tabel="accir"
            />

            <AttachmentFab
                docId={Number(id)}
                docType="accir"
            />
        </Grid>
    )
}

export default Detail